const propsMixin = {
  props: {
    id: {
      type: [String, Number],
      default: null,
      validator: function(value) {
        if (value === null) return true;

        const id = value.toString();
        const validIdPattern = /^[a-zA-Z_][\w-]*$/;

        if (!validIdPattern.test(id)) {
          console.warn(
            `Warning (v-searchable-select):\n\n` +
              `The ID "${id}" doesn't follow recommended HTML5 ID validation rules.\n\n` +
              `For best practice, IDs should be unique and:\n` +
              ` 1. Start with a letter or underscore\n` +
              ` 2. Contain only letters, numbers, hyphens, or underscores\n` +
              ` 3. Be at least one character long\n\n` +
              `(A random ID will be used as fallback if no ID is provided).\n\n`
          );
          // Return true to prevent Vue console error, we'll use fallback
          return true;
        }

        return true;
      }
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Array, Object, String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    optionId: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    metaLabel: {
      type: String,
      default: null
    },
    groupValues: {
      type: String,
      default: null
    },
    groupLabel: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    },
    gray: {
      type: Boolean,
      default: false
    },
    search: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: null
    },
    error: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    minChars: {
      type: Number,
      default: 2
    },
    disabled: {
      type: Boolean,
      default: false
    },
    simpleSelect: {
      type: Boolean,
      default: false
    },
    desktopFullscreen: {
      type: Boolean,
      default: false
    },
    fullscreenTrigger: {
      type: String,
      default: "open-fullscreen-search"
    },
    trending: {
      type: Array,
      default: () => []
    },
    minWidth: {
      type: Number,
      default: null
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    preserveSearch: {
      type: Boolean,
      default: false
    },
    emitNewOptions: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    address: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uniqId: Math.random()
        .toString(36)
        .substring(2, 9),
      mounted: false
    };
  },
  watch: {
    options: {
      handler() {
        this.internalOptions = this.getInternalOptions();
      },
      deep: true
    }
  },
  mounted() {
    this.mounted = true;
  },
  computed: {
    formatAddress() {
      if (this.address) {
        let data = this.address.replace(/{|}|\\|"/g, "").split(",");
        let address = [];
        data.forEach(element => {
          let el = element.split(":")[1];
          if (el !== "null") {
            address.push(el);
          }
        });
        const map = address.map((l, index) => {
          if (address.length === 4 && index === 1) {
            return l + ",";
          }
          if (address.length === 5 && index === 2) {
            return l + ",";
          } else if (address.length === 6 && index === 3) {
            return l + ",";
          }
          return l;
        });
        return map.join(" ");
      }
      return null;
    },
    customResult() {
      return !!this.$scopedSlots["custom-result"];
    },
    customNoResult() {
      return !!this.$scopedSlots["custom-no-result"];
    },
    optionHeight() {
      if (this.small) return 40;
      if (this.search) return 46;
      return 50;
    },
    hasTrending() {
      return this.trending.length > 0;
    },
    getGroupLabel() {
      return this.hasTrending && !this.searching ? "label" : this.groupLabel;
    },
    getGroupValues() {
      return this.hasTrending && !this.searching ? "topics" : this.groupValues;
    },
    show() {
      if (this.fullscreenOpen) {
        return true;
      } else if (this.desktopFullscreen || this.mobile) {
        return false;
      }

      return true;
    }
  }
};

export default propsMixin;
